module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pgmonospaced"
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "calibre2",
    attrs: {
      "id": "pgepubid00000"
    }
  }, [_vm._v("TOM, THE BOOTBLACK;")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre3",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_vm._v("OR,")]), _vm._v(" "), _c('h2', {
    staticClass: "calibre4",
    attrs: {
      "id": "pgepubid00002"
    }
  }, [_vm._v("THE ROAD TO SUCCESS")]), _vm._v(" "), _c('h2', {
    staticClass: "calibre4",
    attrs: {
      "id": "calibre_pb_1"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("By HORATIO ALGER, Jr.")])]), _vm._v(" "), _c('h4', {
    staticClass: "c",
    attrs: {
      "id": "pgepubid00003"
    }
  }, [_vm._v("Author of \"Joe's Luck,\" \"Frank Fowler, the Cash Boy,\" \"Tom Temple's Career,\""), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\n  \"The Errand Boy,\" \"Tom Turner's Legacy,\" etc., etc.")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre3",
    attrs: {
      "id": "pgepubid00004"
    }
  }, [_c('br', {
    staticClass: "calibre1"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6540914","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0001.vue
// module id = 57
// module chunks = 0